import * as React from "react";
const SvgFiRrEngineWarning = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-engine-warning_svg__a)">
      <path
        fill="#062147"
        d="M12 4a8.01 8.01 0 0 0-8 8c.376 10.589 15.626 10.586 16 0a8.01 8.01 0 0 0-8-8m0 14c-7.929-.252-7.928-11.749 0-12 7.93.252 7.928 11.75 0 12m1-9v3a1 1 0 0 1-2 0V9a1 1 0 1 1 2 0m11 3a12.03 12.03 0 0 1-2.743 7.637 1.001 1.001 0 0 1-1.543-1.274 10.05 10.05 0 0 0 0-12.726 1 1 0 1 1 1.543-1.274A12.03 12.03 0 0 1 24 12.001M4.286 18.364a1 1 0 1 1-1.542 1.274 12.065 12.065 0 0 1 0-15.274 1 1 0 0 1 1.542 1.274 10.05 10.05 0 0 0 0 12.726M13 15.001a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-engine-warning_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEngineWarning;
